import "./App.css";
import SearchBar from "./components/SearchBar";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <SearchBar></SearchBar>
      <Footer></Footer>
    </div>
  );
}

export default App;
